module.exports = __webpack_public_path__ + "img/videoSurveillance.af7bf269.svg";